(function ($, sd) {
    sd.TabSelection = (function() {

        var getTabToSelect = function () {
            var queryString = window.location.search.substring(1).split('&');
            for (var i = 0; i < queryString.length; i++) {
                var keyVal = queryString[i].split('=');
                if (keyVal[0] === "tab") {
                    return keyVal[1];
                }
            }
            return '';
        };

        var setFirstTabAsActive = function () {
            $('.tabs-nav li').first().addClass('is-active');
            $(".tab-body .tab-pane").first().addClass('is-active');
        };

        var setSelectedTabAsActive = function (tab) {
            $(".tabs-nav li.tab-" + tab).addClass('is-active');
            $(".tab-body #tab-" + tab).addClass('is-active');
        }

        var setFirstTabAsActiveOnMobile = function () {
            $('.tabs .headered-panel').first().removeClass('is-collapsed');
        };

        var setSelectedTabAsActiveOnMobile = function (tab) {
            $('.tabs #tab-' + tab).removeClass('is-collapsed');
        }

        var tabIsValid = function (tab) {
            return $("#tab-" + tab).length;
        }

        var setActiveTabOnDesktop = function () {
            var tab = getTabToSelect();

            if (tab && tabIsValid(tab)) {
                setSelectedTabAsActive(tab);
            } else {
                setFirstTabAsActive();
            }
        };

        var setActiveTabOnMobile = function () {
            var tab = getTabToSelect();

            if (tab && tabIsValid(tab)) {
                setSelectedTabAsActiveOnMobile(tab);
            } else {
                setFirstTabAsActiveOnMobile();
            }
        };

        return {
            setActiveTabOnDesktop: setActiveTabOnDesktop,
            setActiveTabOnMobile: setActiveTabOnMobile
        };

    })();
})(jQuery, (window.SD || (window.SD = {})));